module.exports = __webpack_public_path__ + "static/img/052.01ecbb3.png";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/052.png
// module id = h0EK
// module chunks = 0